import api from './api'

/**
 * Serviço para gerenciar configurações do usuário
 * Endpoint: /api/users/me/config
 */
export const UserConfigService = {
  /**
   * Busca as configurações do usuário autenticado
   * @returns {Promise} Configurações do usuário
   */
  async getConfig() {
    try {
      const response = await api.get('/api/users/me/config')
      return response.data
    } catch (error) {
      // Se for 404 (primeira vez), retornar null para usar padrões
      if (error.response?.status === 404) {
        console.log('Configurações não encontradas, usando valores padrão')
        return null
      }
      throw error
    }
  },

  /**
   * Atualiza ou cria configurações do usuário
   * @param {Object} config - Objeto com notificationSettings, privacySettings e appearanceSettings
   * @returns {Promise} Configurações atualizadas
   */
  async updateConfig(config) {
    const response = await api.put('/api/users/me/config', config)
    return response.data
  },

  /**
   * Atualização parcial das configurações
   * @param {Object} partialConfig - Parte das configurações a atualizar
   * @returns {Promise} Configurações atualizadas
   */
  async patchConfig(partialConfig) {
    const response = await api.patch('/api/users/me/config', partialConfig)
    return response.data
  },

  /**
   * Restaura configurações para valores padrão
   * @returns {Promise} Configurações padrão
   */
  async resetConfig() {
    const response = await api.delete('/api/users/me/config')
    return response.data
  },

  /**
   * Retorna valores padrão para uso local quando não há config no backend
   */
  getDefaultConfig() {
    return {
      notificationSettings: {
        newFeedback: true,
        oneOnOneScheduled: true,
        pdiUpdated: true,
        campaignInvite: true,
        goalDeadline: true,
        skillEndorsement: true,
        teamAnnouncement: true,
        platformUpdates: false,
        channels: ['email', 'push'],
        digestFrequency: 'DAILY',
      },
      privacySettings: {
        showEmail: false,
        showPhone: false,
        showSocialMedia: true,
        showSkills: true,
        allowAnonymousFeedback: true,
        showFeedbackStats: true,
        feedbackVisibility: 'MANAGER_ONLY',
        shareProgressWithManager: true,
        shareProgressWithTeam: false,
      },
      appearanceSettings: {
        theme: 'DARK',
        primaryColor: 'teal',
        fontSize: 'MEDIUM',
        dashboardLayout: 'CARDS',
        compactMode: false,
        showAvatars: true,
        animations: true,
      },
    }
  },
}

export default UserConfigService
